import React from "react";
import { default as WTableBody } from "@mui/material/TableBody";

function TableBody(props) {
  return <WTableBody {...props} />;
}

export default TableBody;
